export const NAMESPACE = 'portfolios'
